import { EditDataCell } from './editdatacell';
export default EditDataCell;